<template>
  <header class="TcHeader">
    <nav class="flex justify-center">
      <div @click="reloadPage" class="logo cursor-pointer">
        <img src="/assets/img/coiico-logo.svg" alt="coiico logo">
      </div>
      <div class="flex items-center" v-if="$root.page=='welcome'">
        <div class="flex-auto text-left px-2">
          <img src="/assets/img/gobierno canarias.png" style="margin-left:auto;margin-right:auto; height: 70px;"/>
        </div>
        <div class="flex-auto text-center px-2">
          <img src="/assets/img/unioneuropea.png" style="height: 70px;">
        </div>
        <div class="flex-auto text-right px-2">
          <img src="/assets/img/canariasavanza.png" style="margin-left:auto;margin-right:auto; height: 70px;"/>
        </div>
        <div class="flex-auto text-center px-2">
          FONDO EUROPEO DE <br>DESARROLLO REGIONAL
        </div>
      </div>

      <div id="headerUser" class="flex-grow text-center w-full" v-if="$root.page!='welcome'">
        <div class="px-2 flex justify-center items-center overflow-hidden">
          <template v-if="$root.access_token && $root.user">
            <img :src="$root.user.avatar" class="h-12 w-12 rounded-full" />
            <span class="text-xl ml-3">
              {{ $root.user.name }}, Nº Colegiado {{ $root.user.number }}
            </span>
          </template>
          <template v-else-if="$root.external_user">
            <span class="h-12 w-12"></span>
            <span class="text-xl ml-3 text-left">
              {{ $root.external_user.name }}
              {{ $root.external_user.surname1 }}
              {{ $root.external_user.surname2 }}, DNI {{ $root.external_user.dni }}
            </span>
          </template>
          <template v-else>
            <span class="w-full"><!-- Usuario anónimo --></span>
          </template>
        </div>
      </div>
      <div v-if="$root.access_token && $root.user" id="headerLogout" @click="$root.logOut()" class="header-nav-item mr-10 whitespace-nowrap">
        <span class="mr-3 whitespace-nowrap">Cerrar sesión</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
      </div>
      <div v-if="$root.page=='login-public'" @click="$root.logOut()" class="header-nav-item ml-auto mr-10 whitespace-nowrap">
        <span class="mr-3 whitespace-nowrap">Terminar sesión pública</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
      </div>
      <div v-if="$root.access_token && $root.user" id="headerHome" @click="$root.setPage('home')" class="header-nav-item">
        <span class="mr-3">Inicio</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      </div>
      <div v-if="!$root.access_token && $root.page!='welcome'"
        @click="$root.setPage('welcome')"
        class="header-nav-item flex-grow text-right">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-gray-400 ml-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'TcHeader',
  props: ['page','access_token'],
  data () {
    return {}
  },
  methods: {
    reloadPage: function() {
      window.location.reload();
    }
  }
}
</script>